import { getRawQuestionnaire } from '../utils/trainingConfig';

export function useGetQuestionnaire(variant) {
  return getRawQuestionnaire(variant);
}
